export const routes = {
  home: "/",
  success: "/success",
  terms: "/terms",
  privacy: "/privacy",
  cancellation: "/cancellation",
  faq: "/faq",
  paymentStatus: "/payment/:id",
};
